<div
  class="tp-tooltip"
  [ngClass]="{
    show: showTooltip,
    hide: !showTooltip,
    'position-top': showTooltip?.position === 'top',
    'position-right': showTooltip?.position === 'topRight',
    'position-left': showTooltip?.position === 'topLeft'
  }"
  [ngStyle]="{ top: showTooltip?.y + 'px', left: showTooltip?.x + 'px' }"
>
  <div
    id="tooltip"
    class="tp-tooltip__text-container"
    [innerHTML]="showTooltip?.text"
    [ngClass]="{
      'pos-top-right': showTooltip?.position === 'topRight',
      'pos-top-left': showTooltip?.position === 'topLeft',
      'pos-bottom': showTooltip?.position === 'bottom',
      'pos-bottom-right': showTooltip?.position === 'bottomRight',
      'pos-bottom-left': showTooltip?.position === 'bottomLeft'
    }"
  ></div>
</div>
